import { useState, useEffect } from 'react';
import './AppDownloadBanner.css';

// ─── 상수 ────────────────────────────────────────────────────────────────────

const DISMISS_KEY = 'app_download_banner_dismissed';
const DISMISS_DURATION_MS = 7 * 24 * 60 * 60 * 1000; // 7일

// ─── SVG 배지 ─────────────────────────────────────────────────────────────────

function AppStoreBadge() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 160 48"
      width="140"
      height="42"
      role="img"
      aria-label="App Store에서 다운로드"
      className="app-download-banner__badge-svg"
    >
      <rect width="160" height="48" rx="8" fill="#000" />
      {/* Apple 로고 */}
      <path
        d="M22 14.5c1.4-1.7 2.3-4 2.1-6.3-2 .1-4.5 1.4-5.9 3.1-1.3 1.5-2.4 3.9-2.1 6.1 2.2.2 4.5-1.2 5.9-2.9zm2.3 3.6c-3.3-.2-6.1 1.9-7.7 1.9-1.6 0-4-1.8-6.6-1.7-3.4.1-6.5 2-8.2 5.1-3.5 6.1-.9 15.1 2.5 20.1 1.7 2.4 3.6 5.1 6.2 5 2.5-.1 3.4-1.6 6.4-1.6 3 0 3.8 1.6 6.5 1.5 2.7 0 4.4-2.4 6-4.9 1.9-2.8 2.7-5.5 2.7-5.6-.1 0-5.2-2-5.2-7.9-.1-5 4-7.4 4.2-7.5-2.3-3.4-5.9-3.7-6.8-3.4z"
        fill="#fff"
        transform="translate(10, 6) scale(0.55)"
      />
      {/* 텍스트 */}
      <text x="52" y="17" fill="#fff" fontSize="9" fontFamily="system-ui, sans-serif" letterSpacing="0.5">Download on the</text>
      <text x="50" y="32" fill="#fff" fontSize="16" fontFamily="system-ui, sans-serif" fontWeight="600" letterSpacing="0.3">App Store</text>
    </svg>
  );
}

function GooglePlayBadge() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 160 48"
      width="140"
      height="42"
      role="img"
      aria-label="Google Play에서 다운로드"
      className="app-download-banner__badge-svg"
    >
      <rect width="160" height="48" rx="8" fill="#000" />
      {/* Play 아이콘 (삼각형) */}
      <polygon points="12,10 12,38 34,24" fill="#fff" transform="translate(4, 2) scale(0.75)" />
      {/* 컬러 오버레이로 그라데이션 효과 */}
      <polygon points="12,10 23,21 12,24" fill="#00d2ff" opacity="0.7" transform="translate(4, 2) scale(0.75)" />
      <polygon points="12,38 23,27 12,24" fill="#ff3d57" opacity="0.7" transform="translate(4, 2) scale(0.75)" />
      <polygon points="34,24 23,21 23,27" fill="#ffbc00" opacity="0.7" transform="translate(4, 2) scale(0.75)" />
      {/* 텍스트 */}
      <text x="52" y="17" fill="#fff" fontSize="9" fontFamily="system-ui, sans-serif" letterSpacing="0.5">GET IT ON</text>
      <text x="50" y="32" fill="#fff" fontSize="16" fontFamily="system-ui, sans-serif" fontWeight="600" letterSpacing="0.3">Google Play</text>
    </svg>
  );
}

// ─── QR 플레이스홀더 ─────────────────────────────────────────────────────────

function QRPlaceholder() {
  return (
    <div className="app-download-banner__qr" aria-label="QR 코드 (추후 교체 예정)">
      <svg viewBox="0 0 64 64" width="56" height="56" xmlns="http://www.w3.org/2000/svg">
        {/* QR 외곽 패턴 시뮬레이션 */}
        <rect x="2" y="2" width="24" height="24" rx="2" fill="none" stroke="currentColor" strokeWidth="2.5" />
        <rect x="8" y="8" width="12" height="12" rx="1" fill="currentColor" />
        <rect x="38" y="2" width="24" height="24" rx="2" fill="none" stroke="currentColor" strokeWidth="2.5" />
        <rect x="44" y="8" width="12" height="12" rx="1" fill="currentColor" />
        <rect x="2" y="38" width="24" height="24" rx="2" fill="none" stroke="currentColor" strokeWidth="2.5" />
        <rect x="8" y="44" width="12" height="12" rx="1" fill="currentColor" />
        {/* 중앙 도트 패턴 */}
        <rect x="32" y="30" width="4" height="4" fill="currentColor" />
        <rect x="38" y="30" width="4" height="4" fill="currentColor" />
        <rect x="44" y="30" width="4" height="4" fill="currentColor" />
        <rect x="50" y="30" width="4" height="4" fill="currentColor" />
        <rect x="56" y="30" width="4" height="4" fill="currentColor" />
        <rect x="32" y="36" width="4" height="4" fill="currentColor" />
        <rect x="44" y="36" width="4" height="4" fill="currentColor" />
        <rect x="56" y="36" width="4" height="4" fill="currentColor" />
        <rect x="32" y="42" width="4" height="4" fill="currentColor" />
        <rect x="38" y="42" width="4" height="4" fill="currentColor" />
        <rect x="50" y="42" width="4" height="4" fill="currentColor" />
        <rect x="32" y="48" width="4" height="4" fill="currentColor" />
        <rect x="44" y="48" width="4" height="4" fill="currentColor" />
        <rect x="56" y="48" width="4" height="4" fill="currentColor" />
        <rect x="38" y="54" width="4" height="4" fill="currentColor" />
        <rect x="44" y="54" width="4" height="4" fill="currentColor" />
        <rect x="50" y="54" width="4" height="4" fill="currentColor" />
        <rect x="56" y="54" width="4" height="4" fill="currentColor" />
      </svg>
    </div>
  );
}

// ─── 메인 컴포넌트 ────────────────────────────────────────────────────────────

export default function AppDownloadBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(DISMISS_KEY);
    if (!dismissed) {
      setIsVisible(true);
      return;
    }
    const dismissedAt = parseInt(dismissed, 10);
    if (Date.now() - dismissedAt > DISMISS_DURATION_MS) {
      localStorage.removeItem(DISMISS_KEY);
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, Date.now().toString());
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="app-download-banner" role="complementary" aria-label="앱 다운로드">
      <button
        className="app-download-banner__close"
        onClick={handleDismiss}
        aria-label="배너 닫기"
        type="button"
      >
        ✕
      </button>

      <p className="app-download-banner__title">모바일 앱으로 더 편하게</p>

      <div className="app-download-banner__content">
        <QRPlaceholder />

        <div className="app-download-banner__badges">
          <a
            href="#app-store"
            className="app-download-banner__badge-link"
            aria-label="App Store에서 다운로드"
          >
            <AppStoreBadge />
          </a>
          <a
            href="#google-play"
            className="app-download-banner__badge-link"
            aria-label="Google Play에서 다운로드"
          >
            <GooglePlayBadge />
          </a>
        </div>
      </div>
    </div>
  );
}
